import { useMemo } from 'react';

import { UnifiedDialogEntry } from '../../../../types';

export const useFilteredMessages = (
  entries: UnifiedDialogEntry[],
  activeFilter: string,
): UnifiedDialogEntry[] => {
  return useMemo(() => {
    if (activeFilter === 'All') return entries;

    return entries.filter((entry) => {
      if (activeFilter === 'Calls') {
        return ['call_header', 'call_segment', 'call_missed', 'call_abandoned'].includes(entry.entry_type);
      }
      if (activeFilter === 'Transcripts') {
        return ['call_segment', 'lve_segment', 'voicemail_segment'].includes(entry.entry_type);
      }
      if (activeFilter === 'SMS') {
        return ['sms', 'sms_failed'].includes(entry.entry_type);
      }
      if (activeFilter === 'Voicemails') {
        return ['voicemail_header', 'voicemail_segment', 'voicemail_simple'].includes(entry.entry_type);
      }
      if (activeFilter === 'LVE') {
        return ['lve_header', 'lve_segment'].includes(entry.entry_type);
      }
      if (activeFilter === 'Notes') {
        return entry.entry_type === 'internal_note';
      }
      if (activeFilter === 'Emails') {
        return entry.entry_type === 'email';
      }
      if (activeFilter === 'Context') {
        return entry.entry_type === 'context';
      }
      return true;
    });
  }, [entries, activeFilter]);
};
